import {
	type GraphQLSingularResponse,
	type IEnvironment,
	type RequestParameters,
} from 'relay-runtime';

import { fg } from '@atlaskit/platform-feature-flags';
import { createRelayEnvironment } from '@atlassian/relay-environment/createRelayEnvironment';
import { type AGGError, captureErrors, isStepUpAuthError } from '@atlassian/relay-errors';
import { SSRQueryResponseCache } from '@atlassian/relay-query-responses';

const getLoggingAndMetricsHelper = () => {
	return {
		logNonBreakingErrors: () => {},
		logError: () => {},
		logErrorRetry: () => {},
		logQueryFallbackToPost: () => {},
	};
};

export const ssrCache: SSRQueryResponseCache = new SSRQueryResponseCache({
	cacheName: 'relay-cache/v2/AGG',
	size: Infinity,
	ttl: Infinity,
});

/**
 * @deprecated use useRelayEnvironment() from react-relay to get this environment instead of using it directly
 */
export const __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__: IEnvironment =
	createRelayEnvironment({
		networkOptions: {
			getLoggingAndMetricsHelper,
			withErrorHandling: (source: Promise<Response>) => source,
			validateResponse: (request: RequestParameters, response: GraphQLSingularResponse) => {
				const errors = 'errors' in response ? response.errors : undefined;
				if (errors != null) {
					const requestId = response?.extensions?.gateway?.request_id;

					captureErrors(errors as AGGError[], { operationName: request.name, requestId });

					if (fg('platform_relay_redirect_on_step_up_auth_studio')) {
						const { hasStepUpAuthError, stepUpUrl } = isStepUpAuthError(errors as AGGError[]);
						if (hasStepUpAuthError && stepUpUrl) {
							window.location.href = stepUpUrl;
						}
					}
				}
				return true;
			},
			onInvalidResponse: () => {},
			queryResponseCache: ssrCache,
			isServer: (globalThis as any).__SERVER__ ?? false,
		},
	});
